import { render } from "./Universities.vue?vue&type=template&id=5f070420&scoped=true"
import script from "./Universities.vue?vue&type=script&lang=js"
export * from "./Universities.vue?vue&type=script&lang=js"

import "./Universities.vue?vue&type=style&index=0&id=5f070420&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5f070420"

export default script